import api from '../../api';
import { TTransaction, TTransactionsParams } from './transactions.types';

const transactionsURL = '/bookie/regulator/transactions';

// Regulator - Financial Transaction History

export const queryTransactions = (params: TTransactionsParams) =>
  api.get<TTransaction[]>(transactionsURL, { params }).then((res) => res.data);
